import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import useAppVersion from '../../../util/hooks/useAppVersion';
import drawerWidth from '../../../components/navigation/NavigationHelper';

/**
 * VersionDisplay Component
 * Displays backend and frontend version information
 * Uses fixed positioning to overlay on the sidebar drawer
 */
const VersionDisplay = () => {
    const { backendVersion, frontendVersion, loading, error } = useAppVersion();
    const containerRef = useRef(null);

    useEffect(() => {
        // Debug: Check if component is rendering
        if (!loading) {
            console.log('VersionDisplay rendered:', { backendVersion, frontendVersion, error });
        }
    }, [loading, backendVersion, frontendVersion, error]);

    if (loading) {
        return null; // Don't show anything while loading
    }

    return (
        <Box
            ref={containerRef}
            sx={{
                position: 'fixed',
                bottom: 60, // Positioned above Copyright component (which is at bottom: 0)
                left: 0,
                width: `${drawerWidth}px`,
                px: 2,
                py: 1,
                textAlign: 'left',
                zIndex: 1400, // Higher than drawer z-index (drawer is 1200, modal is 1300)
                pointerEvents: 'none', // Allow clicks to pass through
                backgroundColor: 'transparent',
            }}
        >
            <Typography
                variant="caption"
                component="div"
                sx={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.75rem',
                    lineHeight: 1.5,
                    fontFamily: 'inherit',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                }}
            >
                BE: {backendVersion}
            </Typography>
            <Typography
                variant="caption"
                component="div"
                sx={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.75rem',
                    lineHeight: 1.5,
                    fontFamily: 'inherit',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                }}
            >
                FE: {frontendVersion}
            </Typography>
        </Box>
    );
};

export default VersionDisplay;

